import { useEffect, useRef } from 'react';

import { useMount } from './mount';

export function useInterval({ callback, interval }) {
  const intervalId = useRef();
  const mounted = useMount();

  function cleanUp() {
    if (intervalId.current) {
      intervalId.current = clearInterval(intervalId.current);
    }
  }

  useEffect(
    function effect() {
      return cleanUp;
    },
    []
  );

  useEffect(
    function effect() {
      cleanUp();

      function intevalCallback() {
        if (!mounted.current) return;

        callback();
      }

      if (Number.isFinite(interval) && interval > 0) {
        intervalId.current = setInterval(intevalCallback, interval);
      }
    },
    [callback, interval]
  );
}
